import { render } from "./GenealogyDetail.vue?vue&type=template&id=7a4456d9&scoped=true"
import script from "./GenealogyDetail.vue?vue&type=script&lang=js"
export * from "./GenealogyDetail.vue?vue&type=script&lang=js"

import "./GenealogyDetail.vue?vue&type=style&index=0&id=7a4456d9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4456d9"]])

export default __exports__